var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse, _path29, _ellipse2, _ellipse3, _polygon3, _path30, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle, _rect12, _rect13, _rect14, _rect15, _circle2, _rect16, _ellipse4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSinsolicitudesCenfotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 679.65 682.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9cc8ff;}.cls-2,.cls-22{fill:#006aea;}.cls-3{fill:#4d4d4d;}.cls-4{fill:#e1bf7d;}.cls-5{fill:#ebf6fc;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:#d1d4d4;}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:#4296cf;stroke:#4296cf;}.cls-10,.cls-11,.cls-16,.cls-20,.cls-21,.cls-22,.cls-9{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-12{fill:#ffe28e;}.cls-10{stroke:#ffeab9;}.cls-11{stroke:#ffe28e;}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#radial-gradient);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:#deb87d;stroke:#deb87d;}.cls-17{fill:url(#linear-gradient-5);}.cls-18{fill:#dbf2fc;}.cls-19{fill:#00479b;}.cls-20,.cls-21{fill:none;}.cls-20{stroke:#00479b;}.cls-21,.cls-22{stroke:#006aea;}.cls-21{stroke-width:13px;}.cls-22{stroke-width:4px;}.cls-23{fill:#999;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 787.36,
    y1: 338.99,
    x2: 737.13,
    y2: 342.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#b9d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a4ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a0caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#add2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c3ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 849.11,
    y1: 346.75,
    x2: 770.11,
    y2: 352.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 747.15,
    y1: 649.96,
    x2: 798.27,
    y2: 649.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#75a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#235fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03438f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1097.39,
    cy: 258.99,
    fx: 1110.8706437110907,
    fy: 272.60333536973235,
    r: 19.16,
    gradientTransform: "matrix(-0.82, 0.06, 0.06, 0.85, 1684.27, 7.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5dd9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 869.19,
    y1: 653.98,
    x2: 910.61,
    y2: 653.98,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 882.04,
    y1: 345.06,
    x2: 814.38,
    y2: 343.69,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.14,347.94C282.41,429.65,399.6,461.08,478.77,457c140.37-7.25,256.23-130.7,254-179.46-1.47-32.35-54.39,5.12-136.4-11C573.33,262,508.83,259,488.2,215.72,468.63,174.65,505.77,136.25,484,98c-15.88-27.86-54.22-40.21-82.44-31.33-17.17,5.4-21.62,15.83-78.64,93.15-34.22,46.42-35.19,46.16-40.3,56.3C265.64,249.76,250,305,261.14,347.94Z",
    transform: "translate(-257.38 -63.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456.05,228.5c2.34,12.12-7.91,16.38-24.72,47.76-13.44,25.06-12.91,33.56-18.08,39.77A21.23,21.23,0,0,1,409,319.8c-15.7,11.82-29.66,42.36-49,52.07-25.34,12.73-69.13-5.67-75.66-32.55a4,4,0,0,1-.4-1.94c7.14-87.92,26.7-106.17,26.7-106.17,11-10.25,39.12-16.63,95.38-29.39a40.13,40.13,0,0,1,11.39-1C434.21,201.75,453.19,213.63,456.05,228.5Z",
    transform: "translate(-257.38 -63.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M936.57,670.9c-9.29,46.92-160.2,72-263.47,74.78-150.24,4-287.12-37.13-283.65-54.59,3.14-15.78,116.25,12.44,277.47-29.43C773.29,634,830.68,594.07,887.79,615.58,914.88,625.78,940.83,649.4,936.57,670.9Z",
    transform: "translate(-257.38 -63.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M806.05,212.34l29.81,2.57a9.59,9.59,0,0,1,8.68,4.19,9.81,9.81,0,0,1-1.6,12A83.41,83.41,0,0,0,831,242.82c-8.37,10.05-9.16,15.86-12.81,16.63-4.34.92-11.86-5.5-25.85-36.53Z",
    transform: "translate(-257.38 -63.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M805.91,211.86c2.53.32,5,.54,7.53.82l7.48.66c2.5.23,5,.38,7.48.58l7.5.48h-.07a19.49,19.49,0,0,1,6.37.43,15.18,15.18,0,0,1,7,3.92,19,19,0,0,1,5,9.27,23,23,0,0,1-1,13.29L852,242.45A82.79,82.79,0,0,0,853.48,256c.77,4.13,1.45,7.62,1.9,10.38a30.24,30.24,0,0,1,.41,3.81c0,.29,0,.63,0,1v.5a5.52,5.52,0,0,1-.07.55,7.87,7.87,0,0,1-.22,1.23l-.18.69a3.57,3.57,0,0,1-.13.41L855,275l-.35.92-.62,1.25-.32.63-.08.16-.13.22-.27.45c-.36.59-.72,1.19-1.1,1.77-.07.11-.27.39-.41.58l-.45.62-.94,1.24-.48.6-.26.32-.37.42c-.49.56-1,1.11-1.52,1.65s-1.05,1.07-1.6,1.58-1.5,1.33-2.28,1.95-1.62,1.26-2.45,1.85l-.63.43-.79.5c-.53.33-1.06.65-1.6,1a42.21,42.21,0,0,1-14.26,5,41.14,41.14,0,0,1-13.71-.08c-.53-.08-1.06-.18-1.58-.28s-1.1-.23-1.46-.33c-.81-.2-1.62-.44-2.42-.69a50.37,50.37,0,0,1-4.73-1.75c-1.24-.57-2.27-1.1-3.39-1.72s-2.2-1.27-3.14-1.89c-1.5-1.05-2.94-2.18-4.32-3.35-.38-.32-.6-.54-.84-.78l-.73-.72L786.35,285l-.69-.75c-.22-.25-.47-.53-.61-.72-.33-.42-.66-.84-1-1.27-.62-.86-1.26-1.74-1.83-2.59s-.87-1.52-1.3-2.28l-.62-1.15-.31-.57-.22-.52c-.58-1.38-1.21-2.79-1.67-4.14s-.79-2.57-1.15-3.86-.55-2.43-.8-3.66l-.34-1.8c-.09-.58-.16-1.17-.23-1.75-.15-1.16-.3-2.32-.4-3.48a91.36,91.36,0,0,1,2.07-26.73l4.34-19.81.64-.08c1.11-.14,2.2-.29,3.29-.38s2.18-.15,3.24-.2,2.12,0,3.15,0,2,0,3.05.14a39.63,39.63,0,0,1,5.74.84,26.21,26.21,0,0,1,2.67.72A23.71,23.71,0,0,1,805.91,211.86Zm.28,1c-.32,1.27-.64,2.42-.91,3.59l-.75,3.37c-.46,2.17-.82,4.2-1.11,6.12l-.38,2.79-.27,2.61c-.08.84-.14,1.65-.18,2.45l-.13,2.26,5-19.89c7.75,3.87,14.62,7.85,20.69,11l2.22,1.1,1.07.53c.35.17.69.3,1,.45.69.26,1.35.6,2,.81s1.21.35,1.77.53,1,.07,1.44.11h.17l.11-.07.21-.13.38-.25a3,3,0,0,0,0-.67,1.65,1.65,0,0,0-.07-.32,1,1,0,0,0-.13-.26l-.2-.32c-.14-.2-.28-.4-.44-.6l-.23-.28c-.09-.09-.14-.16-.34-.36a15.75,15.75,0,0,0-2.18-1.81,20.51,20.51,0,0,0-2-1.28c-.73-.41-1.38-.73-2.22-1.11a28.05,28.05,0,0,0-3.48-1.33c-.6-.18-1.2-.35-1.8-.49l-1.13-.26-1.26-.25a30.09,30.09,0,0,0-5.09-.45,31.87,31.87,0,0,0-6,.41,37.84,37.84,0,0,0-6.11,1.56,35.91,35.91,0,0,0-5.68,2.6c-.45.26-.88.52-1.32.8l-1.14.75c-.66.46-1.31.94-1.93,1.44s-1.27,1.08-1.76,1.55-.77.73-1.14,1.11-.72.78-1.06,1.18l-.4.5-.28.34c-.18.24-.35.48-.52.73l-.25.37c-.07.1-.19.3-.2.32a7.43,7.43,0,0,0-.35.69l-.07.18,0,.09v0l0,.07a.49.49,0,0,0,.1.15l.33-.21.17-.1a.71.71,0,0,0,.21-.16l.5-.43c.32-.24.74-.66,1.14-1l2.72-2.46a48.14,48.14,0,0,1,6.4-4.84,42.12,42.12,0,0,1,15.55-5.65,76.2,76.2,0,0,1,17-.65L832.6,221a5.65,5.65,0,0,0,4.51,3.25,4.26,4.26,0,0,0,4.11-2.1,3.78,3.78,0,0,0,.44-2.29,4.54,4.54,0,0,0-1-2.28,6,6,0,0,0-4.77-2.11h-.08l-7.4-.8c-2.48-.23-5-.51-7.43-.7l-7.42-.62C811.1,213.14,808.63,212.94,806.19,212.82Z",
    transform: "translate(-257.38 -63.82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M769.53,394.92c-2.79,8.24-6.53,7.06-10.7,1.65-.38-2.62-1-6.87-2.05-12.11-1.42-7.33-2-8.58-2.81-13.88-.28-1.8-.18-1.48-1.4-14-.77-7.86-1-9.5-1.26-13.28-.33-4.21-.54-7.68-.66-10.07l22.3-.92c.08,1.87.2,4.72.35,8.19.43,9.47.56,10.58.58,13.57a115.62,115.62,0,0,1-.71,14c-.77,6.64-1.59,8.14-2.58,15.51C769.92,388.45,769.65,392.44,769.53,394.92Z",
    transform: "translate(-257.38 -63.82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M859.6,409.06h.11a6.41,6.41,0,0,0,5.95-6.69c-.08-1.73-.14-3.67-.18-5.78-.14-7.32.19-8.64-.13-13.88-.11-1.78-.14-1.45-1.63-13.68-.93-7.68-1.1-9.29-1.62-13-.16-1.15-.33-2.25-.48-3.28a6.41,6.41,0,0,0-7.45-5.35l-10.63,1.87a6.41,6.41,0,0,0-5.2,7.45c.1.51.19,1,.29,1.57,1.64,9.14,1.75,10.22,2.38,13.09a105.29,105.29,0,0,0,3.82,13.16c2.26,6.17,3.44,7.42,6.1,14.23.85,2.18,1.56,4.18,2.14,5.93A6.38,6.38,0,0,0,859.6,409.06Z",
    transform: "translate(-257.38 -63.82)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "513.69 311.74 499.37 313.25 496.04 242.38 510.37 240.88 513.69 311.74"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M771.39,375.84c-4.83.58-9.73,1.14-14.6,1.65l-.25,0-.22-.43a69.39,69.39,0,0,1-3.62-8.7q-1.53-4.36-2.65-8.76A142.32,142.32,0,0,1,746.59,342c-.39-2.94-.73-5.88-1-8.83-.12-1.48-.23-2.95-.31-4.43s-.2-2.95-.14-4.43a27,27,0,0,1,4.12-13.51,24.27,24.27,0,0,1,3.7-4.61l.38-.44,14.33-1.51.47.41a31.36,31.36,0,0,1,9.19,4.41,20.18,20.18,0,0,1,5.09,5.06,13.48,13.48,0,0,1,2.21,5.27,13.63,13.63,0,0,1,.2,2.61l0,2.6a127.75,127.75,0,0,1-1.6,20.28,96.31,96.31,0,0,1-4.57,17.87,56.06,56.06,0,0,1-3.28,7.34A23.09,23.09,0,0,1,771.39,375.84Zm-.64-.55c-1.86-4.42-3.38-8.3-4.87-12l-4.11-10.37c-2.54-6.5-4.63-12.22-6.24-17.56a85,85,0,0,1-3.26-15.16l-.19-1.83a6.46,6.46,0,0,1,0-1.81,7,7,0,0,1,1.79-3.59,20.73,20.73,0,0,1,4.68-3.8,54.41,54.41,0,0,1,8.77-4.44l.47.4-14.33,1.5.38-.44a24,24,0,0,1,4.12,4.25,26.29,26.29,0,0,1,2.71,4.31,26.79,26.79,0,0,1,2.66,8.75c.2,1.47.21,2.95.28,4.43s.08,2.95.1,4.43c0,3,0,5.92-.14,8.88a142.41,142.41,0,0,1-1.79,17.84c-.48,3-1.08,6-1.82,9a70.51,70.51,0,0,1-2.79,9l-.47-.41C761.38,376.15,766,375.71,770.75,375.29Z",
    transform: "translate(-257.38 -63.82)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M797.31,388.73l26.12-2.48q-2.67,25-5.35,50l-15.48,3.6Q800,414.3,797.31,388.73Z",
    transform: "translate(-257.38 -63.82)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M797,388.46c8.76-.9,17.59-1.8,26.4-2.63l.24,0,.22.49,24.06,53.17L856.74,459l-31.86,6.52-15.58,3.19-46.23,9.45,10.11-35.22c1.8-6.25,3.78-12.22,5.89-17.75s4.34-10.62,6.52-15.18,4.33-8.6,6.27-12.15S795.53,391.2,797,388.46Zm.65.54a136.74,136.74,0,0,0,7.77,16.2,114,114,0,0,0,8.91,13.42,111.52,111.52,0,0,0,9.16,10.4c3,3,5.86,5.55,8.54,7.82L795.9,411.07l15.38-4-23,26L823,386.21l.46.47C814.87,387.5,806.29,388.26,797.64,389Z",
    transform: "translate(-257.38 -63.82)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M768.91,626.24l24.46,1.29L800.84,403l-15.64,8c-4.59,39.49-8.49,80.63-11.47,123.33Q770.45,581.53,768.91,626.24Z",
    transform: "translate(-257.38 -63.82)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M769.19,626l24.19,1.32-.24.22c.35-9.35.57-18.71.83-28.06s.41-18.72.3-28.09-.52-18.74-1-28.12l-1.75-28.15a535.56,535.56,0,0,1-.79-56.22,80.93,80.93,0,0,1,2.17-14c.56-2.32,1.22-4.64,1.88-7l2-7A95.38,95.38,0,0,0,799.64,417c.61-4.66.66-9.34.92-14l.41.26-7.87,3.92-7.84,4,.06-.1c-.56,4.47-1,8.94-1.5,13.41s-.91,8.95-1.32,13.42l-.62,6.72a25.26,25.26,0,0,0,.06,6.78,30.63,30.63,0,0,0,2,7c1,2.36,2.14,4.72,3.36,7.09s2.38,4.73,3.34,7.07a29.74,29.74,0,0,1,1.94,6.92,25.36,25.36,0,0,1,0,6.74l-.61,6.68q-1.29,13.35-2.85,26.68c-2.09,17.79-4.62,35.55-7.76,53.32-1.56,8.89-3.33,17.78-5.25,26.67l-1.5,6.67L773,612.91c-.58,2.22-1.13,4.45-1.75,6.67a22.65,22.65,0,0,1-1,2.95A27.87,27.87,0,0,0,769.19,626Zm-.57.52c-.21-1-.54-2-.82-3.29s-.52-2.77-.73-3.79c-.45-2.27-.83-4.53-1.22-6.8s-.71-4.54-1.06-6.81l-.91-6.8q-1.67-13.62-2.54-27.23c-1.14-18.14-1.3-36.27-.69-54.36q.48-13.56,1.51-27.09l.55-6.76a25.44,25.44,0,0,1,1.23-6.7,29.88,29.88,0,0,1,3.17-6.52c1.39-2.14,3-4.25,4.62-6.36s3.26-4.21,4.67-6.34a31.31,31.31,0,0,0,3.31-6.45,26.22,26.22,0,0,0,1.44-6.64l.79-6.7,1.6-13.39c.51-4.47,1.07-8.93,1.54-13.4V411l.06,0,7.79-4.06,7.77-4.12.41-.22v.48c-.06,4.68-.32,9.35,0,14a94.13,94.13,0,0,0,2,14.11l1.52,7.08c.51,2.36,1,4.71,1.41,7.07a80,80,0,0,1,1.24,14.09,535.44,535.44,0,0,1-4.52,56l-3.62,28c-1.15,9.33-2.19,18.66-2.91,28s-1.24,18.69-1.57,28-.76,18.7-1,28.06v.23h-.24Z",
    transform: "translate(-257.38 -63.82)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M792.8,400.87l39-1.74L828,318.25c-2.23-.09-5.32-.16-9,0-3.29.12-5.82.35-10.05.73-5.77.52-6.21.69-9.29.9A102.18,102.18,0,0,1,789,320Z",
    transform: "translate(-257.38 -63.82)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M793,400.68l19.35-.83c6.46-.27,12.95-.62,19.41-1l-.21.24c-.2-3.37-.32-6.74-.6-10.11A89,89,0,0,0,829.48,379a115.08,115.08,0,0,0-6.2-20c-2.65-6.63-5.6-13.25-8.06-19.88a129.2,129.2,0,0,1-5.75-20l17.69,17.61c-1.38.24-2.74.49-4.1.69-.68.1-1.35.21-2,.29s-1.32.14-2.06.31c-2.89.57-5.73,1-8.65,1.3-1.54.18-3,.33-4.48.46l-1.3.11L803,340c-1.1.06-2.08.09-3.05.09a78.73,78.73,0,0,1-11.63-.86l19.91-20.12c-.34,2.83-.69,5.67-1.17,8.56s-.93,5.82-1.5,8.82c-1.07,6-2.41,12.23-3.8,18.87s-2.92,13.67-4.39,21.19S794.44,392,793,400.68Zm-.36.39c-2.1-4.81-4.15-10.35-6.27-16.29s-4.27-12.4-6.29-19.25-4-14.07-5.71-21.57c-.89-3.74-1.69-7.55-2.45-11.4s-1.46-7.74-2.11-11.65l-2.91-17.32,22.81-2.81c2.69-.33,5.32-.69,7.88-1l1.82-.27.86-.14,1.13-.15c1.7-.23,3.52-.4,5.22-.51,3.57-.2,7.22-.22,10.82-.13.87,0,1.87.14,2.81.22s1.9.2,2.85.31c1.89.21,3.78.47,5.65.71L848,302.31l-1.55,15.08a127.94,127.94,0,0,1-3.85,20.44c-1.83,6.84-4.14,13.7-6.15,20.55a114.21,114.21,0,0,0-4.3,20.47,86.45,86.45,0,0,0-.5,10.15c0,3.38.23,6.74.35,10.12v.22h-.22c-6.52.26-13,.49-19.54.8Z",
    transform: "translate(-257.38 -63.82)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M801.6,327.76",
    transform: "translate(-257.38 -63.82)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "632.99 555.91 609.64 563.13 548.37 352.78 571.71 345.56 632.99 555.91"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M890.66,619.89l-23.54,7.38-.29.09-.13-.32c-3.54-8.47-6.87-17-10.09-25.58s-6.33-17.18-9.35-25.8q-9.09-25.89-17.3-52t-15.77-52.45c-2.38-8.82-4.4-17.74-6-26.79-.8-4.53-1.44-9.09-2-13.7a131.88,131.88,0,0,1-.87-14v-.34l.23-.07L829,409.06l.1,0,.32.26a57.93,57.93,0,0,1,10.72,11.48,88.5,88.5,0,0,1,7.68,12.74A105,105,0,0,1,853.33,447c1.5,4.56,2.68,9.17,4,13.76,5.07,18.39,9.74,36.83,13.91,55.06s7.92,36.23,11.18,53.71c1.61,8.72,3.19,17.35,4.56,25.77S889.68,612,890.66,619.89Zm-.58-.32c-4.13-9.59-7.9-18.84-11.63-28s-7.26-18-10.76-26.81c-7-17.58-13.43-34.63-19.46-51.47s-11.59-33.45-16.73-50.12c-1.24-4.17-2.62-8.33-3.67-12.53a84.8,84.8,0,0,1-2.14-12.86,77.64,77.64,0,0,1,0-13.55,61.51,61.51,0,0,1,3.06-14.81l.42.23-23.35,7.22.22-.42a127.92,127.92,0,0,1,6.79,12.29q3.07,6.24,5.72,12.6c3.56,8.47,6.64,17.08,9.37,25.79q7.84,26.24,14.86,52.72t13.35,53.17q3.12,13.35,6,26.78c1.9,9,3.67,17.95,5.23,27l-.42-.23Z",
    transform: "translate(-257.38 -63.82)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M732.82,288.37",
    transform: "translate(-257.38 -63.82)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M714.7,272.92",
    transform: "translate(-257.38 -63.82)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M836.6,366.48",
    transform: "translate(-257.38 -63.82)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M772.71,304.48",
    transform: "translate(-257.38 -63.82)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M740.88,286.89",
    transform: "translate(-257.38 -63.82)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M753.86,652.55c-5.27,8-7.9,12-6.19,14.32,4.07,5.63,28.61,1.39,42.64-11.85,3.47-3.26,9.54-9,7.58-14.85-2.06-6.18-12.23-10.15-20.07-9.48C767.74,631.54,762.14,640,753.86,652.55Z",
    transform: "translate(-257.38 -63.82)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M786.33,304c1.69,6,4.94,7.73,5.72,8.12,5.75,2.86,15.32-1.23,21.1-11.85a29.74,29.74,0,0,1-2.34-3.56,26.3,26.3,0,0,1-2.83-6.77,47.37,47.37,0,0,1-1-6.39c-.21-1.85-.36-3.71-.46-4.84-.11-1.41-.19-2.6-.25-3.46l-15.94,1.17c.13.84.3,2,.47,3.44.2,1.71.4,3.33.48,5.07a35.15,35.15,0,0,1-.21,6c0,.09,0,.2,0,.34a31.2,31.2,0,0,1-2.37,7.75C788.08,300.36,787.32,302.05,786.33,304Z",
    transform: "translate(-257.38 -63.82)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M776.27,241.27c-.4,7.12-.63,12.17,1.31,18,1.69,5,4.15,8.06,6.55,11,4.17,5.13,7,8.67,11.32,9s7.34-2.48,12.72-7.27c3.45-3.07,7.21-6.41,10-12.57,2.22-4.84,2.77-9,3.45-14.27,1.13-8.7,1.81-13.91.16-19.16-3.13-10-12.86-14.55-20.06-15.18s-17.61,2.25-22.44,11.52C777.08,226.63,776.81,231.51,776.27,241.27Z",
    transform: "translate(-257.38 -63.82)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M789.25,203.42A50.07,50.07,0,0,1,809,205.05c7.91,2.28,13,5.83,17,8.66,2.77,1.94,3.71,3.68,5.59,7,1.19,2.05,3.47,4.15,3.45,4.81l-.18,6c-.1,3.23-2.95,5.56-6.43,5.44h-.08c-2.26-.07-3.74.53-6,1.15a65.15,65.15,0,0,1-9.74,1.7,33.39,33.39,0,0,1-13.9-1,25.87,25.87,0,0,1-10.33-5.51c-3.24-2.95-3.34-4.81-7-8.95a39.4,39.4,0,0,0-3.44-3.42,5.93,5.93,0,0,1-1.53-7.37c1-2.2,2.09-4.4,3.14-6.59Z",
    transform: "translate(-257.38 -63.82)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M908.2,661c2.32,9.25,3.48,13.87,1.08,15.56-5.71,4-27.44-7.9-36.27-25-2.18-4.21-6-11.59-2.21-16.51,4-5.18,14.9-5.67,22.07-2.51C902.1,636.64,904.56,646.48,908.2,661Z",
    transform: "translate(-257.38 -63.82)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M796.55,380.6v-.09c.36-2.75,2.62-4.7,4.87-4.19s5.17,1.14,8.37,1.77c7.66,1.52,9.05,1.52,14.53,2.78,1.85.43,1.51.38,14.26,3.91,8,2.22,9.69,2.66,13.52,3.78,2.39.7,4.54,1.35,6.39,1.91,2.08.64,3.2,3.22,2.5,5.75l-2.41,8.58c-.71,2.5-2.94,4-5,3.32l-4.51-1.45c-9.51-3.05-10.64-3.35-13.62-4.4-6.73-2.37-11.83-4.7-13.67-5.55-6.39-3-7.67-4.15-14.72-7.56-3.17-1.53-6-2.78-8.2-3.72A4.48,4.48,0,0,1,796.55,380.6Z",
    transform: "translate(-257.38 -63.82)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M743,335l.08,0c2.39-1.23,5.2-.39,6.06,1.82s2,5.06,3.31,8.16c3.1,7.4,3.88,8.6,6,14,.71,1.83.54,1.51,4.92,14.41,2.75,8.1,3.34,9.79,4.61,13.69,1.93,6,2,6.26,2.08,6.54.33,1.72.19,4.54-2.84,8.67l-2.64,1c-4,0-9-.57-11.25-3.92-.34-.5-.11-.4-1.38-4.67-2.93-9.86-3.33-11-4.18-14.13-1.9-7.09-2.93-12.76-3.28-14.82-1.24-7.13-1-8.89-2.3-16.83-.56-3.58-1.15-6.67-1.66-9.12A4.46,4.46,0,0,1,743,335Z",
    transform: "translate(-257.38 -63.82)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 742.45,
    cy: 320.63,
    rx: 7.39,
    ry: 7.69,
    transform: "translate(-278.76 -8.89) rotate(-4.18)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M774.64,413.48",
    transform: "translate(-257.38 -63.82)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 783.39,
    cy: 370.61,
    rx: 7.39,
    ry: 7.69,
    transform: "translate(-282.29 -5.78) rotate(-4.18)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 738.88,
    cy: 338.36,
    rx: 7.39,
    ry: 7.69,
    transform: "translate(-280.06 -9.1) rotate(-4.18)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "587.86 322.6 607.03 319.22 593.8 238.58 574.63 241.97 587.86 322.6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M845.45,386.12c6.32-1.19,12.59-2.34,18.89-3.45l-.3.43a95.55,95.55,0,0,1-4.44-9.63c-1.32-3.23-2.51-6.49-3.6-9.76q-3.27-9.81-5.58-19.78c-.77-3.33-1.5-6.66-2.13-10-.32-1.68-.63-3.35-.92-5s-.6-3.35-.77-5a38.76,38.76,0,0,1,.3-10.4,35.65,35.65,0,0,1,1.34-5.39,26.89,26.89,0,0,1,2.57-5.6l.43.31-19.17,3.38.31-.43a40.29,40.29,0,0,1,8.54,3.4,19,19,0,0,1,4.9,3.58,10,10,0,0,1,2.39,3.92,10.25,10.25,0,0,1,.41,2.14l.27,2.19a131.63,131.63,0,0,1,.68,18.32c-.18,6.46-.7,13.36-1.42,21-.36,3.84-.75,7.84-1.2,12.12S846.06,381.15,845.45,386.12Zm-.43.61a40.72,40.72,0,0,1-4.8-6.47c-1.56-2.44-3-5.16-4.51-8a149.63,149.63,0,0,1-8-19.29,180.89,180.89,0,0,1-5.94-22l-.56-2.85a19.85,19.85,0,0,1-.41-2.9,18,18,0,0,1,.73-6.16,21.61,21.61,0,0,1,3.25-6.5,27.21,27.21,0,0,1,6.89-6.68l.3-.43L851.11,302h0l.39.32a26.46,26.46,0,0,1,4.21,4.48,36,36,0,0,1,3,4.69,39.44,39.44,0,0,1,3.6,9.76c.38,1.66.61,3.34.88,5s.51,3.36.74,5.05c.46,3.37.84,6.76,1.17,10.16q1,10.19,1,20.53c0,3.45-.07,6.91-.29,10.4A98.37,98.37,0,0,1,864.77,383l-.06.39-.24,0C858,384.55,851.48,385.65,845,386.73Z",
    transform: "translate(-257.38 -63.82)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 362.71,
    y: 117.2,
    width: 393.95,
    height: 565.83,
    rx: 33.97,
    transform: "translate(890.74 692.79) rotate(175.65)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 380.84,
    y: 128.62,
    width: 380.98,
    height: 546.84,
    rx: 24.34,
    transform: "translate(914.15 695.74) rotate(175.65)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 648.08,
    y: 523.35,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(1148.66 1020.99) rotate(175.65)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 454.91,
    y: 346.76,
    width: 241.96,
    height: 19.21,
    rx: 9.61,
    transform: "translate(919.78 604.18) rotate(175.65)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 459.88,
    y: 400.03,
    width: 241.96,
    height: 19.21,
    rx: 9.61,
    transform: "translate(933.75 710.19) rotate(175.65)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 463.17,
    y: 443.29,
    width: 241.96,
    height: 19.21,
    rx: 9.61,
    transform: "matrix(-1, 0.08, -0.08, -1, 943.61, 796.34)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 466.46,
    y: 486.56,
    width: 241.96,
    height: 19.21,
    rx: 9.61,
    transform: "translate(953.46 882.5) rotate(175.65)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 434.77,
    y: 190.39,
    width: 128.1,
    height: 128.1,
    rx: 24.34,
    transform: "translate(758.14 406.47) rotate(175.65)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 559.07,
    y: 528.62,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(971.29 1038.27) rotate(175.65)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 476.22,
    y: 536.43,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(806.42 1060.15) rotate(175.65)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 481.37,
    y: 100.58,
    width: 114.37,
    height: 43.79,
    rx: 8.46,
    transform: "translate(-265.12 -22.6) rotate(-4.35)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 279.7,
    cy: 39.23,
    r: 29.73
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 583,
    y: 290.82,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "matrix(1, -0.08, 0.08, 1, -277.9, -14.79)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 581.53,
    y: 271.51,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "translate(-276.44 -14.96) rotate(-4.35)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 579.23,
    y: 241.31,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "translate(-274.15 -15.22) rotate(-4.35)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 575.76,
    y: 199.64,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "translate(-271 -15.6) rotate(-4.35)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 387.1,
    cy: 186.68,
    r: 63.63
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 680.58,
    y: 333.4,
    width: 117.78,
    height: 8.74,
    rx: 3.6,
    transform: "translate(77.67 -431.28) rotate(35.62)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 781.63,
    cy: 366.52,
    rx: 10.55,
    ry: 10.18,
    transform: "translate(1.87 990.02) rotate(-77.89)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.18,
    y1: 132.7,
    x2: 203.58,
    y2: 240.66
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 192.06,
    y1: 146.94,
    x2: 289.98,
    y2: 230.72
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 226.62,
    y1: 485.5,
    x2: 272.7,
    y2: 544.54
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 272.7,
    y1: 482.62,
    x2: 233.82,
    y2: 550.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 310.43,
    y1: 477.78,
    x2: 356.51,
    y2: 536.82
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 356.51,
    y1: 474.9,
    x2: 317.63,
    y2: 542.58
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 402.58,
    y1: 472.79,
    x2: 448.66,
    y2: 531.83
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 448.66,
    y1: 469.91,
    x2: 409.78,
    y2: 537.59
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1237.84,312.44",
    transform: "translate(-257.38 -63.82)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M673.86,685c1.21,4.09-41.82,26.55-97,33.82-12.82,1.69-87.66,11.56-96-11.24-6.45-17.61,26.28-56,57.6-55.81,25.89.14,31.25,26.51,68.1,36.44C643.1,698.08,672.84,681.61,673.86,685Z",
    transform: "translate(-257.38 -63.82)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinsolicitudesCenfotec);
export default __webpack_public_path__ + "static/media/SinsolicitudesCenfotec.b1aebbb2701d1ed2068d938c14e8df40.svg";
export { ForwardRef as ReactComponent };